<template>
  <section>
    <qx-img-dialog ref="imgDialog" />
    <div class="detail-item-box" :class="{'horizontal': detailItemHorizontal}">
      <div class="detail-item-vertical" v-for="(item, index) in detailItemList" :key="index">

        <span v-if="item.label" class="detail-item-label">{{item.label}}<qx-tips :content="item.remark" v-if="item.remark" :isFixPosition="false"/>：</span>
        <template v-if="item.type === 'img'">
          <span class="detail-item-value">

             <span
                 class="detial-item-img"
                 v-if="(orderDetail.base && orderDetail.base[propName] && orderDetail.base[propName][item.value] && typeof orderDetail.base[propName][item.value] ==='object') "
                 style="display:inline;"
             >
               <span  v-for="(item,index) in orderDetail.base[propName][item.value]" :key="index" >
<!--                  <img-->
<!--                      class="cur"-->
<!--                      :src="item"-->
<!--                      v-if="item.substring(item.lastIndexOf('.') + 1) !== 'pdf'"-->
<!--                      @click="previewImg(item)"-->
<!--                  />-->
                 <a
                     class="cur"
                     v-if="item.substring(item.lastIndexOf('.') + 1) === 'pdf'"
                     :href="item"
                     target="_blank"
                 >
                  <img class="cur" style="cursor:pointer" src="~images/pdf-icon.png" />
                </a>
               </span>

            </span>
             <span
                class="detial-item-img"
                v-else-if="(orderDetail.base && orderDetail.base[propName] && orderDetail.base[propName][item.value] && typeof orderDetail.base[propName][item.value] ==='string') "
             >
               <img
                 class="cur"
                 :src="orderDetail.base[propName][item.value]"
                 v-if="orderDetail.base[propName][item.value].substring(orderDetail.base[propName][item.value].lastIndexOf('.') + 1) !== 'pdf'"
                 @click="previewImg(orderDetail.base[propName][item.value])"
               />
               <a
                   class="cur"
                   v-if="orderDetail.base[propName][item.value].substring(orderDetail.base[propName][item.value].lastIndexOf('.') + 1) === 'pdf'"
                   :href="orderDetail.base[propName][item.value]"
                   target="_blank"
               >
                    <img style="cursor:pointer" src="~images/pdf-icon.png" />
                  </a>
             </span>
            <span v-else  class="detial-item-img-empty">
              未上传
            </span>
          </span>
        </template>
        <template v-else>
          <span
            class="detail-item-value" :style=" item.isDifferent?'color: red':''"
          >{{orderDetail && orderDetail.base && orderDetail.base[propName] && (orderDetail.base[propName][item.value] || '--')}}</span>

          <span
            class="error"
            v-if="(orderDetail && orderDetail.base && orderDetail.baseVer) && (orderDetail.baseVer[propName][item.value]) &&
            (orderDetail.base[propName][item.value] !== orderDetail.baseVer[propName][item.value])"
          >
            <span class="label">修改为：</span>
            {{orderDetail.baseVer[propName][item.value]}}
          </span>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    detailItemHorizontal: {
      type: Boolean,
      default: false,
    },
    detailItemList: {
      type: Array,
      default: () => [],
    },
    propName: {
      type: String,
      default: '',
    },
    orderDetail: {
      type: Object,
      default: () => ({}),
    },
    moneyTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      isVerity: '',
    };
  },
  methods: {
    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
  },
  mounted () {
    this.isVerity = this.$route.query.isVerity;
  },
};
</script>

<style lang="scss" scoped>
.detail-item-box {
  margin: 8px 0;
  &.horizontal {
    .error {
      display: block;
      .label {
        display: inline-block;
        width: 100px;
      }
    }
  }
  .detail-item-vertical {
    line-height: 2.2;
    .detail-item-label {
      min-width: 100px;
      display: inline-block;
      position: relative;
    }
    .detail-item-value {
      margin-right: 8px;
      .detial-item-img {
        display: inline-block;
        min-height: 40px;
        padding: 8px 8px 8px 0;
        img {
          width: 80px;
          height: 80px;
          margin-right: 16px;
        }
      }

      .detial-item-img-empty {
        display: inline-block;
        min-height: 40px;
        width: 96px;
        height: 92px;
        margin-right: 16px;
        text-align: center;
        line-height: 80px;
        border: 0.5px solid #ccc;
        color: #ccc;
      }
    }

    .profitBox{
      width: 320px;
      display: inline-block;
      background: #FAFAFA;
      border:1px solid #DCDFE6;
      margin-left: 25px;
      //padding-left: 15px;

      .td_1{
        height:30px;
        line-height: 30px;
        text-align: right;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-left: 15px;
      }
      .th_1{
        border-bottom:1px solid #DCDFE6;
        text-align: center;
      }
      .td_2{
        text-align: center;
      }
      .equal{
        position: relative;
        top: 0;
        left: -20px;
      }

    }

  }

}
</style>

<style lang="scss">
.el-popover.popoverBackB{
  background: #FFFF00 !important;
}
</style>
